module.exports = __webpack_public_path__ + "img/no-image.625d1aff.jpg";